export default __webpack_public_path__ + "static/integrations_shopify-e32669b66f2bc46d221ad68808a80a22.png";